export default {
  additionalInfoSignUp: `If you are interested in seeking our financial advice, you can request a meeting by clicking the button below. Alternatively, please contact our office directly.`,
  goToDashboard: `Go to dashboard`,
};
